module.exports = __webpack_public_path__ + "img/09.f9954336.jpg";